import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ProductPricing } from '@galaxy/billing';
import { SubscriptionTierInterface } from '@galaxy/partner';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AppConfigService } from '../../../app-config.service';
import { AssignedSalespersonDialogComponent } from '../../../assigned-salesperson/assigned-salesperson-dialog/assigned-salesperson-dialog.component';
import { AssignedSalespersonService } from '../../../assigned-salesperson/assigned-salesperson.service';
import { UpgradeSubscriptionTierService } from '../../../upgrade-subscription-tier/upgrade-subscription-tier.service';
import { ManageSubscriptionsService } from '../manage-subscriptions.service';

@Component({
  selector: 'app-current-plan',
  templateUrl: './current-plan.component.html',
  styleUrls: ['./current-plan.component.scss'],
  standalone: false,
})
export class CurrentPlanComponent implements OnInit {
  @Input() showAction: boolean;

  @Input() detailsUrl: string;
  @Input() detailsTextKey: string;
  currentTierId$: Observable<string>;
  isFreeTier$: Observable<boolean>;
  subscriptionPrice$: Observable<number>;
  subscriptionPricing$: Observable<ProductPricing>;
  renewDate$: Observable<Date>;
  renewDateEpoch$: Observable<number>;
  partnerSinceDate$: Observable<Date>;
  isOnFreeTrial$: Observable<boolean>;
  freeTrialEndDate$: Observable<Date>;
  similarNextSubscriptionTier$: Observable<SubscriptionTierInterface>;
  isActiveSubscription$: Observable<boolean>;
  salesDialogConfig$: Observable<MatDialogConfig>;

  constructor(
    private readonly manageSubscriptionsService: ManageSubscriptionsService,
    private readonly appConfigService: AppConfigService,
    private readonly translateService: TranslateService,
    private readonly router: Router,
    private readonly upgradeSubscriptionWithCurrentService: UpgradeSubscriptionTierService,
    private readonly assignedSalespersonService: AssignedSalespersonService,
    private readonly dialog: MatDialog,
    private readonly snackService: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.currentTierId$ = this.manageSubscriptionsService.currentTierId$;
    this.isFreeTier$ = this.manageSubscriptionsService.isFreeTier$;
    this.renewDate$ = this.manageSubscriptionsService.renewDate$;
    this.renewDateEpoch$ = this.renewDate$.pipe(map((date) => date.valueOf()));
    this.partnerSinceDate$ = this.manageSubscriptionsService.partnerSinceDate$;
    this.subscriptionPricing$ = this.manageSubscriptionsService.subscriptionPricing$;
    this.subscriptionPrice$ = this.manageSubscriptionsService.subscriptionPrice$;
    this.isOnFreeTrial$ = this.manageSubscriptionsService.isOnFreeTrial$;
    this.freeTrialEndDate$ = this.manageSubscriptionsService.freeTrialEndDate$;
    this.salesDialogConfig$ = this.assignedSalespersonService.dialogConfig$;
    this.similarNextSubscriptionTier$ = this.manageSubscriptionsService.mostSimilarSubscriptionTier$;
    this.isActiveSubscription$ = this.upgradeSubscriptionWithCurrentService.isActiveSubscription(
      this.manageSubscriptionsService.currentTier$,
    );
  }

  bannerAction(supportsSelfUpgrade: boolean): void {
    if (supportsSelfUpgrade) {
      this.goToDetails();
      return;
    }
    this.openContactSalesModal();
  }

  goToDetails(): void {
    this.router.navigateByUrl(this.detailsUrl);
  }

  private openContactSalesModal(): void {
    this.salesDialogConfig$.pipe(take(1)).subscribe((dialogConfig) => {
      this.dialog.open(AssignedSalespersonDialogComponent, dialogConfig);
    });
  }
}
